import React from 'react';
import {
  Container, Image
} from 'react-bootstrap';
// import ReactPlayer from 'react-player';
import { Tron } from './Tron';

export const APIBackendMacOs = () => {
  
  let homeTron = {
    title: 'Workspace ONE Excel Add-In (Beta) API',
    description: 'This is the Installation page for the MacOs Caching API for the Workspace ONE Excel Add-In',
    body: <><p>Because the Excel add-in is much more responsive with a caching layer, I've chosen to show how to deploy
      using an in-memory cache. </p>
      <p>I show the back end installation separately from running the application because you can choose
        to run the api on a separate Computer/VM <b>However</b>, you can definitely run the Caching API locally on a
        bigger computer</p>
      <p>Below you will find the step by step instructions.</p>
    </>
  };
  
  
  return (
    
    <Container>
      <Tron tronProps={homeTron}/>
      <Container>
        {/*<h3>Video overview of the Caching API server installation</h3>*/}
        {/*<ReactPlayer url="https://www.youtube.com/watch?v=eDUXEjtgqo8" config={{*/}
        {/*  youtube: {*/}
        {/*    playerVars: { showinfo: 1, controls: true }*/}
        {/*  }*/}
        {/*}}>*/}
        {/*</ReactPlayer>*/}
        
        
        <h4 id="overview-of-apps">Overview of apps used</h4>
        <p>On MacOs, the in-memory DB is Redis.</p>
        <p>Nodejs is used to run the API backend.</p>
        <p>Optionally, you can choose to put Nginx in front of Nodejs if your
          security team requires it, but I won’t be covering that here. Reach out if you need help.</p>
        <h4 id="requirements">Requirements</h4>
        
        <p>The requirements are pretty light. It's an in-memory cache, so high disk i/o will not be required. The size
          of your environment will determine the RAM size required.</p>
        <p>Here are some general guidelines:</p>
        <ul>
          <li>If your environment has 10000 devices
            <ul>
              <li>Memory requirements should not exceed 500 megabytes. So 4GB for the computer/VM.</li>
              <li>CPU would be 2 Cores/4 Threads.</li>
              <li>Disk space minimal - Same as Windows</li>
            </ul></li>
          <li>If your environment contains 100,000 devices:
            <ul>
              <li>Plan for 4-6 gigabytes of RAM for the cache, which probably means 8-10 GB for the computer/VM.</li>
              <li>CPU would be 2 Cores / 4 threads unless you increase the cluster size beyond 2.</li>
              <li>Disk space requirements are just enough room for the backup of your cache, and the number of backups
                you want to keep. The database files compress somewhat, so the disk size is less than the memory size.
              </li>
            </ul></li>
        </ul>
        <h4 id="download-and-install">Download and install required code and applications</h4>
        <p>So let's get started. The first thing you need to do is go to the <a
          href="https://github.com/vmware-samples/euc-samples">EUC Samples GitHub</a> and download the euc-samples
          repository. Once downloaded, unzip it, and open the euc-samples-master folder, then Windows-Samples,
          Tools &amp; Utilities, and finally Excel Add-In.</p>
        <p>Copy the simple_node_api folder and paste it where you want to run it from. Next, copy the app folder and
          paste it into
          the <span className="textMonospace bg-secondary text-white">simple_node_api/www</span> folder.</p>
        <h5>Install apps using Homebrew</h5>
        <p>There are a few ways to get Nodejs and Redis installed on Macos. Homebrew is one way and I'll show that
          here</p>
        <p>Go to the <a href='https://brew.sh/'>Homebrew site</a> and install Homebrew</p>
        <p>Once installed, run <span
          className="textMonospace bg-secondary text-white">brew install nodejs</span></p>
        <p>Next run <span
          className="textMonospace bg-secondary text-white">brew install redis</span></p>
        <p>Set Redis to run automatically - <span
          className="textMonospace bg-secondary text-white">brew services start redis</span></p>
        <p>If you want to use a nice graphical tool to view your DB, I like <a
          href='https://docs.redisdesktop.com/en/latest/install/'>Redis Desktop Manager</a></p>
        <p>Its not free but its rock solid and available in teh MacOs App Store</p>
        
        <h4 id="run-npm-install">Run NPM Install and verify connection</h4>
        <p>Now open terminal, cd to your simple-node-api folder. Run <span
          className="textMonospace bg-secondary text-white">npm install</span>. If all
          goes well, you should get no errors.</p>
        <p>If you get warnings about vulnerabilities, run <span className="textMonospace bg-secondary text-white">npm audit fix</span> and
          hopefully NPM can automatically upgrade
          the required dependencies to mitigate the vulnerabilities automatically. (Its almost like security magic :)
          )</p>
        
        <h4 id="run-npm-start">Run NPM Start</h4>
        <p>Finally, <span className="textMonospace bg-secondary text-white">run npm start</span> to start the API and be
          ready to connect.</p>
        <p>You should get prompted to install the root certificate which is automatically generated by the
          "office-addin-dev-certs" module I am using for that purpose. Its produced by microsoft and you can see the
          reference <a href='https://www.npmjs.com/package/office-addin-dev-certs'>here</a></p>
        <p>It will install in your keychain and you need to mark the <span
          className="textMonospace bg-secondary text-white">Developer CA for Microsoft Office Add-ins</span> as trusted
        </p>
        
        
        <h3 id="configure-excel">Configure Excel and run the Workspace ONE Excel Add-In</h3>
        <h5>If you are running Excel on the same computer your manifest.xml is ready to use in your simple_node_api
          directory</h5>
        <h4>Use the guides for your platform to setup Excel</h4>
        <Image alt="Configure Excel using the guides" width='800' src='../images/WSONEInstallGuidesLink.png' fluid/>
        <p>Reach out if you have trouble and we will be happy to help you setup the application.</p>
        <p>Next go to the Usage documentation and learn how to use the Workspace ONE Excel Add-In</p>
        <br/>
      </Container>
    </Container>
  );
};

